// TODO(FF-774): Add cache key to respective campaigns + canvas to invalidate appropriately
export const engagementAppGroupIdFeatureFlagsRolloutIdDependencies =
  "/engagement/:app_group_id/feature_flags/:rollout_id/dependencies";
